import { render } from "./VideoPlayerThumbnail.vue?vue&type=template&id=5b5a86f8&ts=true"
import script from "./VideoPlayerThumbnail.vue?vue&type=script&lang=ts"
export * from "./VideoPlayerThumbnail.vue?vue&type=script&lang=ts"

import "./VideoPlayerThumbnail.vue?vue&type=style&index=0&id=5b5a86f8&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__